import React from 'react';
import DashboardPage from './DashboardPage';

const IndexPage = () => {
    return <DashboardPage />;
};

export default IndexPage;
